// @flow
export { default } from './BackgroundColor';



// WEBPACK FOOTER //
// ./src/components/common/BackgroundColor/index.js